import { createFileRoute } from '@tanstack/react-router';
// relative imports
import SourcesPage from '../../../components/source-management/sources-page/SourcesPage';
import LoadingPage from '../../../components/shared/page-components/LoadingPage';

export const Route = createFileRoute('/_authenticated/(sources)/sources/')({
  component: SourcesPage,
  pendingComponent: () => <LoadingPage loadingPage />,
  staticData: {
    configPageId: 'crypto-sources',
    meta: {
      title: 'Source Management | Ledgible',
    },
  },
});
